import * as React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { Lobby } from '../Lobby/Lobby';
import { ProductConfigurator, Source } from '../Configurator/ProductConfigurator';
import { useEffect, useState } from 'react';
import { embeddingService } from '@/ui-kit/services/embedding/EmbeddingService';

/**
 * The style guide is a development-only tool (~109KB minified). Vite `define`-replaces
 * `import.meta.env.DEV` with `false` in a production build, so this collapses to `null` and the
 * `import()` is dead-code-eliminated along with it — leaving the page with no importer at all, so
 * no chunk is emitted for it. A static import would keep the whole subtree in the entry chunk even
 * though the routes below are already dropped. Guarded by src/__tests__/eagerModuleGraph.test.ts.
 */
const StyleGuidePage = import.meta.env.DEV
  ? React.lazy(() => import('@/pages/DesignTokens').then((m) => ({ default: m.StyleGuidePage })))
  : null;

function AppImpl() {
  const [embedded, setEmbedded] = useState(false);

  useEffect(() => {
    embeddingService.start();
    embeddingService.awaitBootstrapping().then(() => {
      setEmbedded(true);
    });
    return () => {
      embeddingService.stop();
    };
  }, []);
  if (!embedded) {
    return null;
  }

  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/configurator/backend-driven/:projectId/product/:productId"
            element={<ProductConfigurator composite={false} source={Source.Backend} />}
          />
          <Route
            path="/configurator/backend-driven/:projectId/composite/:productId"
            element={<ProductConfigurator composite={true} source={Source.Backend} />}
          />
          <Route
            path="/configurator/demo/:projectId/composite/:productId"
            element={<ProductConfigurator composite={true} source={Source.Local} />}
          />
          <Route
            path="/configurator/demo/:projectId/product/:productId"
            element={<ProductConfigurator composite={false} source={Source.Local} />}
          />
          <Route
            path="/configurator/bucket/:projectId/composite/:productId"
            element={<ProductConfigurator composite={true} source={Source.Bucket} />}
          />
          <Route
            path="/configurator/bucket/:projectId/product/:productId"
            element={<ProductConfigurator composite={false} source={Source.Bucket} />}
          />
          {StyleGuidePage && (
            <Route
              path="/style-guide/:section?/:tab?"
              element={
                <React.Suspense fallback={null}>
                  <StyleGuidePage />
                </React.Suspense>
              }
            />
          )}
          {StyleGuidePage && (
            <Route
              path="/storybook/:section?/:tab?"
              element={
                <React.Suspense fallback={null}>
                  <StyleGuidePage />
                </React.Suspense>
              }
            />
          )}
          <Route path="/" element={<Lobby />} />
        </Routes>
      </Router>
    </>
  );
}

export const App = AppImpl;
